"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isScheduler.js
// module id = 282
// module chunks = 3